import './TreeView.css';
import React, { FC, useRef, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { LeftPaneButtons } from '../LeftPaneButtons';
import { Accordion } from '../Accordion';
import icons from '../../../../icons';
import { MainProgram } from './MainProgram';
import { ChildSequences } from './ChildSequences';
import { TreeViewAssets } from "./TreeViewAssets";
import { LeftPaneContext } from '../LeftPaneContext';


export const TreeView: FC = observer(() => {
  const treeViewRef = useRef(null);
  const { library, openSequence, isRunning } = useContext(LeftPaneContext);

  const addChildSequence = () => {
    const application = library.currentApplication;
    const newSequence = application.newSequence();
    application.selectSequenceByName(newSequence.name);
    openSequence(library, application, newSequence);
  };

  return (
    <>
      <div ref={treeViewRef} className="tree-view-content">
        <Accordion
          title='Assets'
          keepOpenState
          className={cx('assets-accordion', {
            disabled: isRunning
          })}
        >
          <TreeViewAssets />
        </Accordion>
        <Accordion
          title='Sequences'
          keepOpenState
          altActionId="ml_button_add_sequence"
          altActionIcon={icons.plusRaw}
          altActionCallback={addChildSequence}
          altActionDisabled={isRunning || library.currentApplication.isReadOnly()}
        >
          <ChildSequences treeViewRef={treeViewRef} />
        </Accordion>
        <Accordion
          title='Main Program'
          keepOpenState
          isDefaultOpen={true}
          // leaving these as comments because future work requires them!
          // altActionIcon={icons.plusRaw}
          // altActionCallback={() => console.warn('TODO! callback for main program.')}
        >
          <MainProgram treeViewRef={treeViewRef} />
        </Accordion>
      </div>
      <hr className="ml-widget-divider"/>
      <LeftPaneButtons/>
    </>
  );
});